import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    dataTable: {
      marginTop: theme.spacing(2)
    }
  });
